import { render, staticRenderFns } from "./TelemetryEventGameTollgateOverlay.vue?vue&type=template&id=2d85e0e6&"
import script from "./TelemetryEventGameTollgateOverlay.vue?vue&type=script&lang=js&"
export * from "./TelemetryEventGameTollgateOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports